import { RuleSummaryModel } from './rule-summary-model';

export class RuleModel extends RuleSummaryModel {
  isInherited: boolean;
  conditions: { [key: string]: string };
  exceptions: { [key: string]: string };
}
